export const inRange = (value: number, min: number, max: number) =>
  value >= min && value <= max

export const setCoords = (
  el: HTMLElement,
  { top, left }: { top: number; left: number }
) => {
  if (top || top === 0) el.style.setProperty('top', `${top}px`)
  if (left || left === 0) el.style.setProperty('left', `${left}px`)
}

export const removePointerEvents = (documents: HTMLElement[]) => {
  ;[...documents].forEach((doc) => {
    doc.style.pointerEvents = 'none'
  })
}

export const addPointerEvents = (documents: HTMLElement[]) => {
  ;[...documents].forEach((doc) => {
    doc.style.pointerEvents = 'auto'
  })
}

export const safelyParseJson = (parseString: string) => {
  try {
    return JSON.parse(parseString)
  } catch (e) {
    return null
  }
}
